import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/landing',
    pathMatch: 'full'
  },
  {
    path: '',
    loadChildren: () => import('./master/master.module').then(m => m.MasterModule)
  },
  {
    path: 'landing',
    loadChildren: () => import('./landing-root/landing-root.module').then(m => m.LandingRootModule)
  },
  {
    path:'**',
    redirectTo:'landing'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
